module.exports = __webpack_public_path__ + "static/img/IMG_20240209_190521.d42f284e.jpg";